import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * WebSite Schema with Search Action
 * Add to the main App component or homepage to enable Google search box
 */
export const WebSiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Premier Pharmaceuticals",
    "url": "https://app.premierpharma.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://app.premierpharma.com/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

/**
 * Organization Schema
 * Add to the homepage or main layout component
 */
export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Premier Pharmaceuticals",
    "alternateName": "Premier Pharma",
    "url": "https://app.premierpharma.com",
    "logo": "https://premierpharma-production.s3.us-west-2.amazonaws.com/icons/premier-pharma-dp.svg",
    "description": "Premier Pharmaceuticals offers high-quality pharmaceutical products and solutions to healthcare providers nationwide. Browse our extensive catalog of pharmaceutical supplies with fast, reliable shipping.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-208-639-0241",
      "contactType": "customer service",
      "email": "info@premierpharma.com",
      "areaServed": "US",
      "availableLanguage": ["en"]
    },
    "sameAs": [
      "https://www.facebook.com/people/Premier-Pharma/100092650552829",
      "https://www.instagram.com/premierpharma_/",
      "https://www.linkedin.com/company/premier-pharmaceuticals"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

/**
 * Combined Schema Component
 * Use this on the homepage to add both WebSite and Organization schemas
 */
export const HomePageSchema = () => {
  return (
    <>
      <WebSiteSchema />
      <OrganizationSchema />
    </>
  );
};

const SchemaComponents = {
  WebSiteSchema,
  OrganizationSchema,
  HomePageSchema
};

export default SchemaComponents;
